import { PatientDocument } from "./pages/order/report/ReportForm";

export default [
    { value: 'introduction_static', transcription_key: 'introduction', label: 'INTRODUCTION', noTitle: true },
    { value: 'preamble_static', label: 'PRÉAMBULE', transcription_key: 'preamble' },
    { value: 'identification', label: 'IDENTIFICATION', transcription_key: 'identification' },
    {
        value: 'habits', label: 'ANTÉCÉDENTS ET HABITUDES DE VIE', transcription_key: 'antecedents', sections: [
            { value: 'antecedents', label: 'Antécédents' },
            { value: 'medication', label: 'Médication' },
            { value: 'allergies', label: 'Allergies' },
            { value: 'tobacco', label: 'Tabac' },
        ]
    },
    {
        value: 'history', label: 'HISTORIQUE DE LA MALADIE ACTUELLE DÉCRIT PAR LA TRAVAILLEUSE', transcription_key: false, sections: [
            { value: 'historyOfCurrentDisease', labelTranscription: 'HISTORIQUE DE LA MALADIE ACTUELLE DÉCRIT PAR LA TRAVAILLEUSE', transcription_key: 'historyOfCurrentDisease' },
            { value: 'currentComplaints', label: 'Plaintes actuelles', transcription_key: 'currentComplaints' },
        ]
    },
    { value: 'clinicalExam_static', label: 'EXAMEN PHYSIQUE EN LIEN AVEC LA LÉSION', transcription_key: 'clinicalExam' },
    { value: 'fileReview', label: 'ÉTUDE DES DOCUMENTS FOURNIS PAR LE DEMANDEUR', transcription_key: 'fileReview' },
    { value: 'documentProvided', optionnal: true, transcription_key: 'documentProvided', labelTranscription: "DOCUMENTS FOURNIS PAR LE TRAVAILLEUR", label: (order) => `DOCUMENT${order.sections.documents_count > 1 ? 'S' : ''} FOURNI${order.sections.documents_count > 1 ? 'S' : ''} PAR ${order.mandate.form.patient.gender === 'M' ? 'LE TRAVAILLEUR' : 'LA TRAVAILLEUSE'}`, Component: PatientDocument },
    { value: 'summary', label: 'DISCUSSION', transcription_key: 'summary' },
    { value: 'conclusion_static', label: 'RÉPONSES AUX QUESTIONS DEMANDÉES', transcription_key: 'conclusion' }
]

export const examples = [
    "IRSST Restrictions.pdf",
    "Bras, poignet, épaule.pdf",
    "Entorse Lombaire et cervicale.pdf",
    "Entorse Lombaire.pdf",
    "Protrusion discale postérocentrale.pdf",
]